import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "@src/store";
import {
  DrawerState,
  DrawerType,
  IDrawerState,
  ModifySubscriptionDrawerState,
} from "@src/store/types/drawers";

const initialState = {
  modifySubscription: {
    type: "modifySubscription",
    open: false,
    agencyId: null,
    orgs: [],
    orgId: "",
    stripeSubscriptionId: "",
    subscriptionLinkIds: [""],
    phaseIndex: 0,
    usages: null,
  } as ModifySubscriptionDrawerState,
} as IDrawerState;

const slice = createSlice({
  name: "drawers",
  initialState,
  reducers: (create) => ({
    openDrawer: create.reducer<DrawerState>((state, action) => {
      state[action.payload.type] = action.payload;
    }),
    closeDrawer: create.reducer<DrawerType>((state, action) => {
      delete state[action.payload];
    }),
  }),
});

export const { openDrawer, closeDrawer } = slice.actions;
export const setDrawer = slice.actions.openDrawer;

export const getDrawer =
  <T extends DrawerType>(type: T) =>
  (state: RootState) =>
    state.drawers[type] as Extract<DrawerState, { type: T }> | undefined;

export const isDrawerOpen = (type: DrawerType) => (state: RootState) =>
  state.drawers[type] !== undefined;

export const drawersReducer = slice.reducer;
